import { useEffect } from 'react';
import { getSalesforceEnv, salesforceConfigs, SalesforceEnv } from './salesforceConfigs';
import { initSalesforceChat } from './salesforceChat';
import { loadScript } from './loadScript';
import { reportToSentry } from '../../helpers/sentry';
import { isLocal } from '../../helpers/environment';

const InitSalesforceChat = () => {
  useEffect(() => {
    const initSalesforce = async () => {
      if (isLocal()) return;
      try {
        // Determine environment (salesforceChat v2 is either prod, test or dev)
        const salesforceEnv = getSalesforceEnv();
        await loadScript(salesforceConfigs[salesforceEnv as SalesforceEnv].bootstrapUrl);
        initSalesforceChat(salesforceEnv);
      } catch (error) {
        console.error('Error loading script:', error);
        reportToSentry('Error loading Salesforce Chat script');
      }
    };

    initSalesforce();
  }, []);

  return null;
};

export default InitSalesforceChat;
